module.exports = __webpack_public_path__ + "static/colouring_in_crew-c0ea495d58d98788be25989c4517ab03.pdf";